import React from 'react'
import { HeaderStyles } from './Style'

const Tutorials = (props) => {
    const { subTitle, title } = props

    return (
        <HeaderStyles>
            <div>
                <div className='general-title'>
                    {title}
                </div>
                {/* <div className='general-sub-title'>
                    {subTitle}
                </div> */}
            </div>
        </HeaderStyles>
    )
}

export default Tutorials